/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Gates(props) {
  const { nodes, materials } = useGLTF('/finalgates.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        name="mtfuji100_texture_geo"
        castShadow
        receiveShadow
        geometry={nodes.mtfuji100_texture_geo.geometry}
        material={materials.mtfuji100_tex}
        position={[0, 0, -92.951]}
        scale={0.025}
      />
      <mesh
        name="mtfuji100_startEntrance_geo"
        castShadow
        receiveShadow
        geometry={nodes.mtfuji100_startEntrance_geo.geometry}
        material={materials['rgp_tex.001']}
        position={[-77.422, 15.122, -26.598]}
        scale={0.025}
      />
    </group>
  )
}

useGLTF.preload('/finalgates.glb')
